module.exports = __webpack_public_path__ + "img/docw.6c4e9aa6.svg";